import React from 'react';
import { Link } from 'react-router-dom';
import { Plane, ArrowRight, Compass, Gauge, Rocket } from 'lucide-react';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';
import PageHeroImage from '../components/PageHeroImage';
import AcademyProgramme from '../components/academy/AcademyProgramme';
import SimulationExperiences from '../components/academy/SimulationExperiences';
import SimulatorGallery from '../components/academy/SimulatorGallery';
import WorkshopFacts from '../components/academy/WorkshopFacts';
import '../styles/ServiceEnquiry.css';
import '../styles/KnowledgeAZ.css';
import '../styles/N3uropedia.css';
import '../styles/Academy.css';

const LEVELS = [
  { icon: Compass, label: 'Discover (5–7)', body: 'My First Flight — airports, aircraft and the sensory experience of travel, told at a child-friendly pace.' },
  { icon: Gauge, label: 'Explore (8–11)', body: 'How aircraft work — airport operations, cockpit and flight principles.' },
  { icon: Rocket, label: 'Advance (12–16)', body: 'Flight systems, planning and simulation — building real skills and confidence.' },
];

const AcademyFlight = () => (
  <SubpageShell currentPath="/academy/flight">
    <SEO
      title="Flight Academy — N3URO Academy"
      description="Neuro-inclusive learning pathway in flight: aviation, flight systems and simulation across three age levels."
      canonical="/academy/flight"
      image="https://n3uro.world/img/share-academy-flight.jpg"
    />
    <main className="subpage-hero">
      <PageHeroImage src="/img/academy-flight.webp" alt="N3URO Academy Flight — a pilot guides a young learner in a flight simulator cockpit" testId="hero-image-academy-flight" />
      <nav aria-label="Breadcrumb" style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)', marginBottom: '0.5rem' }}>
        <Link to="/academy" style={{ color: '#5BE9FF' }}>Academy</Link> &middot; Flight
      </nav>
      <span className="subpage-eyebrow"><Plane size={12} /> &nbsp;Flight Academy</span>
      <h1 className="subpage-title">Flight Academy.</h1>
      <p className="subpage-lede">
        A neuro-inclusive learning pathway into aviation. From "My First Flight" to flight systems and
        simulation, across three carefully-paced levels.
        Each 90-minute workshop is kept small, with <span data-testid="workshop-capacity-flight">no more than 12&ndash;14 children per session and age group</span>, so every child has time and space to settle in.
      </p>

      <figure className="ac-hero-figure" data-testid="academy-flight-hero">
        <img src="/img/academy-flight-hero.webp" alt="An aeroplane in N3URO WORLD® colours on a wet runway at sunset" width="1264" height="848" fetchPriority="high" />
      </figure>

      <WorkshopFacts pathway="flight" />

      <section className="service-grid" aria-label="Flight Academy levels">
        {LEVELS.map(({ icon: Icon, label, body }) => (
          <article key={label} className="service-card" style={{ '--accent': '#5BE9FF' }}>
            <span className="service-card-icon" aria-hidden="true"><Icon size={22} strokeWidth={1.75} /></span>
            <h3>{label}</h3>
            <p>{body}</p>
          </article>
        ))}
      </section>

      <SimulatorGallery pathway="flight" />

      <AcademyProgramme code="FL-01" />
      <SimulationExperiences pathway="flight" />

      <section style={{ marginTop: '2rem' }}>
        <Link to="/academy/register-interest?pathway=flight" className="service-enquiry-submit" data-testid="cta-register-flight" style={{ display: 'inline-flex' }}>
          <span>Register interest in Flight Academy</span>
          <ArrowRight size={16} strokeWidth={2.4} />
        </Link>
        <p className="service-enquiry-note" style={{ marginTop: '0.65rem' }}>
          Registering is free. It is not a booking and no payment is taken.
        </p>
      </section>
    </main>
  </SubpageShell>
);

export default AcademyFlight;
